import { render, staticRenderFns } from "./SubscriptionDropdown.vue?vue&type=template&id=5056a804&"
import script from "./SubscriptionDropdown.vue?vue&type=script&lang=js&"
export * from "./SubscriptionDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports